import { render, staticRenderFns } from "./CiAccordion.vue?vue&type=template&id=495e70dc&"
import script from "./CiAccordion.vue?vue&type=script&lang=js&"
export * from "./CiAccordion.vue?vue&type=script&lang=js&"
import style0 from "./CiAccordion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports